



































































import Vue from "vue";
import AdminService from "@/services/adminService";
import { AdminUser } from "@/models/admin-user";

export default Vue.extend({
  data() {
    return {
      adminUsers: [] as AdminUser[],
      isLoaded: false,
      resetting: false,
      deleting: false
    };
  },
  name: "Agreement",

  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const response = await adminService.getUsers();
        if (response && response.status == 200) {
          if (response.data) {
            this.adminUsers = response.data;
            console.log(this.adminUsers);
          }
        }
      }
      this.isLoaded = false;
    },
    async resetPassword(e, username) {
      e.preventDefault();
      if (this.resetting) {
        return;
      }
      if (confirm("Are you sure you want to reset password of " + username)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          const adminService = new AdminService(jwt);
          try {
            const formData = new FormData();
            formData.append("username", username.trim());
            const response = await adminService.resetPasswordUsers(formData);
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async deleteUser(e, username) {
      e.preventDefault();
      if (this.deleting) {
        return;
      }
      if (confirm("Are you sure you want to delete " + username)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          const adminService = new AdminService(jwt);
          try {
            const formData = new FormData();
            formData.append("username", username.trim());
            const response = await adminService.deleteUsers(formData);
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                await this.getList();
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async goToCreateUser() {
      await this.$router.push("/admin-create-users");
    }
  }
});
